<template>
  <v-container class="partners" bg="f">
    <v-headline :level="2" class="partners-headline uppercase"
      >{{ dic.partners.title }} {{ dic.brand }}</v-headline
    >

    <v-carousel :slides="partners">
      <template
        v-slot:default="{
          slides,
          transitionName,
          currId,
          index,
          handleNav,
          handlePag,
          beforeEnter,
          afterLeave,
        }"
      >
        <div class="partners-carousel-container">
          <carousel-nav-button
            v-if="$mq.resize && $mq.above(450)"
            direction="prev"
            :isRounded="true"
            containerTheme="dark"
            pointerTheme="light"
            @navclick="handleNav"
          />

          <carousel-list
            class="partners-list"
            :slides="slides"
            :transitionName="transitionName"
            :currId="currId"
            @before-enter="beforeEnter"
            @after-leave="afterLeave"
            @swipe="handleNav"
          >
            <template v-slot:default="{ slide }">
              <partner-cart :partner="slide" :title="dic.partners.subTitle" />
            </template>
          </carousel-list>

          <carousel-nav-button
            v-if="$mq.resize && $mq.above(450)"
            direction="next"
            :isRounded="true"
            containerTheme="dark"
            pointerTheme="light"
            @navclick="handleNav"
          />
        </div>
        <!-- END PARTNER CAROUSEL CONTAINER -->

        <carousel-pagination
          :index="index"
          :items="slides"
          @pagclick="handlePag"
        />
      </template>
    </v-carousel>
  </v-container>
</template>

<script>
import VHeadline from '@/components/ui/VHeadline'
import VContainer from '@/components/ui/VContainer'

import VCarousel from '@/components/carousel/VCarousel'
import CarouselList from '@/components/carousel/CarouselList'
import PartnerCart from '@/components/ui/PartnerCart'

import { mapState } from 'vuex'

import CarouselPagination from '@/components/carousel/CarouselPagination'
import CarouselNavButton from '@/components/carousel/CarouselNavButton'

export default {
  name: 'SectionPartners',

  components: {
    VHeadline,
    VContainer,

    VCarousel,
    CarouselList,
    PartnerCart,
    CarouselPagination,
    CarouselNavButton,
  },

  computed: {
    ...mapState('partners', ['partners']),
    currentLang() {
      //this need for wake up store listner
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner
      return this.$store.state.main.dic
    },
  },
}
</script>

<style lang="scss" scoped>
.partners {
  &-headline {
    text-align: center;
    display: block;
  }

  &-list {
    text-align: center;
    width: 70%;
  }

  &-carousel-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
}

@media (max-width: 375px), (max-width: 414px) {
  .partners {
    &-list {
      width: 100%;
      height: 410px;
    }
  }
}
</style>
